import logo from './logo.svg';
import './App.css';
import CreateTask from './Compnents/CreateList';

function App() {
  return (
    <div className="App">
     <CreateTask/>
    </div>
  );
}

export default App;
